require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-10-questions-with-andy-orritt.json") })
        }
      }, "path---news-10-questions-with-andy-orritt");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-10-questions-with-andy-orritt!./.cache/json/news-10-questions-with-andy-orritt.json
// module id = 1407
// module chunks = 231608221292675